import React, { useState } from "react";
import homepageStyles from "./homePage.module.css";
import Sphere from "../components/sphere/sphere";
import Jobs from "../components/jobs/jobs";
import Projects from "../components/projects/projects";
import { jobs, projects } from "../constants";
import useMediaQuery from "../hooks/useMediaQuery";
import Sidebar from "../components/sidebar/Sidebar";
import gmail from "../images/gmail.svg";
import github from "../images/github.svg";
import linkedin from "../images/linkedin.svg";

function HomePage(): JSX.Element {
  const [company, setCompany] = useState(jobs[0]);
  const [project, setProject] = useState(projects[0]);

  const tablet = useMediaQuery("(max-width: 780px)");

  return (
    <>
      <main id="main" className={homepageStyles.main}>
        {tablet ? null : <Sidebar />}

        <section className={homepageStyles.intro}>
          <p className={homepageStyles.preheader}>Hi, my name is</p>
          <h1 className={homepageStyles.header}>Elena Soloveva</h1>
          <span className={homepageStyles.line}>
            <p className={homepageStyles.text}>
              I am a full stack web developer based in Ashkelon, Israel. I have
              developed many web applications.
            </p>
            <p className={homepageStyles.text}>
              I enjoy creating beautiful, pixel-perfect accessible,
              human-centered interfaces and highly logical products.
            </p>
          </span>
          {tablet ? null : (
            <span className={homepageStyles.sphere} id="sphere">
              <Sphere />
            </span>
          )}
        </section>
        <section className={homepageStyles.section} id="about">
          <h2 className={homepageStyles.title}>About me</h2>
          <p className={homepageStyles.text}>
            Hello! My name is Elena and I enjoy creating things that live on
            internet.
          </p>
          <p className={homepageStyles.text}>
            I was always fond of studying languages, so I got my first degree in
            linguistics, studying English, German and French , language
            recognition, generation, semantics and syntax. Then I accomplished
            my education with psychology degree.Working some time in HR,
            localization and administrative fields.
          </p>
          <p className={homepageStyles.text}>
            Fast forward to 2018 I was fascinated by yet another language -
            HTML, naturally followed by CSS and JS. To understand better what to
            study next I`ve spent several months studying Java until I finally
            enrolled in a deep 2-year Web Development course by Yandex in
            September 2021.
          </p>
          <p className={homepageStyles.text}>
            These days my time is spent building beautiful human accessible
            websites that solve problems and connect people.
          </p>
          <p className={homepageStyles.text}>
            Here are a few technologies I’ve been working with recently:
          </p>
          <ol className={homepageStyles.skillList}>
            <li className={homepageStyles.skill}>JavaScript (ES6+)</li>
            <li className={homepageStyles.skill}>TypeScript</li>
            <li className={homepageStyles.skill}>React</li>
            <li className={homepageStyles.skill}>Redux</li>
            <li className={homepageStyles.skill}>Cypress</li>
            <li className={homepageStyles.skill}>Jest</li>
            <li className={homepageStyles.skill}>REST API</li>
            <li className={homepageStyles.skill}>Nodejs</li>
            <li className={homepageStyles.skill}>Express</li>
            <li className={homepageStyles.skill}>Nestjs</li>
            <li className={homepageStyles.skill}>Git</li>
            <li className={homepageStyles.skill}>MongoDB</li>
          </ol>
          <p className={homepageStyles.text}>
            When I`m not coding you can find me reading books, travelling or
            petting all the small creatures
          </p>
        </section>
        <section className={homepageStyles.section} id="jobs">
          <h2 className={homepageStyles.title}>Experience</h2>
          <Jobs company={company} setCompany={setCompany} />
        </section>
        <section className={homepageStyles.section} id="projects">
          <h2 className={homepageStyles.title}>Projects</h2>
          <Projects project={project} setProject={setProject} />
        </section>
      </main>
      <footer className={homepageStyles.footer}>
        <div className={homepageStyles.contacts}>
          <ul className={homepageStyles.list}>
            <li>
              <a
                href="mailto:es0528664603@gmail.com"
                className={homepageStyles.link}
              >
                <img className={homepageStyles.img} src={gmail} alt="Gmail" />
              </a>{" "}
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://github.com/ElenaSolov"
                className={homepageStyles.link}
              >
                <img
                  className={homepageStyles.img}
                  src={github}
                  alt="Link to my Github"
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/elena-soloveva-71bb9825a/"
                target="_blank"
                rel="noopener noreferrer"
                className={homepageStyles.link}
              >
                <img
                  className={homepageStyles.img}
                  src={linkedin}
                  alt="Link to my LinkedIn profile"
                />
              </a>
            </li>
          </ul>
        </div>
        <div>
          &copy;2022
          <a
            className={homepageStyles.footerLink}
            href="mailto:es0528664603@gmail.com"
          >
            es0528664603@gmail.com
          </a>
        </div>
      </footer>
    </>
  );
}
export default HomePage;
